const it = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'Sto imparando il <br />cinese su SuperChinese. Unisciti a me!',
	'零基础任性学': 'Impara da zero',
	'听说读写全面提升': "Migliora l'ascolto, la lettura, la scrittura e la conversazione in cinese",
	'趣味对话': 'Conversazione divertente',
	'100+日常对话等你来': '100+ conversazioni quotidiane sono qui per te',
	'智能AI': 'Con tecnologia AI',
	'个性化学习推荐，由浅入深系统学': 'Esperienze di apprendimento personalizzato e sistematico per rendere il tuo apprendimento conta',
	'趣味对话等你来': 'Per te conversazioni divertenti',
	'立即打开': 'Apri subito',
	'我在SuperChinese<br />已累计学习{day}天': 'Sono su SuperChinese<br />Studiato per <span>{day}</span> giorni',
	'我在SuperChinese<br />已连续学习{day}天': 'Sono su SuperChinese<br />Per <span>{day}</span> giorni',
	'学习生词': 'Vocabolario<br />imparato',
	'学习语法': 'Grammatica<br />imparata',
	'口语练习': 'Pratica<br />orale',
	'{n}个': '<span>{n}</span>',
	'{n}次': '<span>{n}</span>volte',
	'点击右上角的按钮,选择在浏览器中打开': 'Clicca il pulsante in alto a destra e scegli di aprire con browser',
	'邀请码': 'Codice d\'invito',
	'用邀请码注册，参与抽大奖': 'Invita i nuovi utenti a registrarsi e a compilare il codice d\'invito per partecipare all\'estrazione.',
}
export default it;